import { useState } from "react";

const DEFAULT_SRC = "/assets/intuit/C2QB_green_btn_med_default.svg";
const HOVER_SRC = "/assets/intuit/C2QB_green_btn_med_hover.svg";

/**
 * Official Intuit "Connect to QuickBooks" button (C2QB).
 * Assets from https://static.developer.intuit.com/resources/Connect_to_QuickBooks_buttons.zip
 */
export default function QuickBooksConnectButton({
  onClick,
  disabled = false,
  className = "",
  type = "button",
}) {
  const [hovered, setHovered] = useState(false);

  return (
    <button
      type={type}
      disabled={disabled}
      className={`inline-block border-0 bg-transparent p-0 cursor-pointer disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setHovered(true)}
      onBlur={() => setHovered(false)}
      aria-label="Connect to QuickBooks"
    >
      <img
        src={hovered && !disabled ? HOVER_SRC : DEFAULT_SRC}
        alt="Connect to QuickBooks"
        width={223}
        height={36}
        className="block h-9 w-[223px] max-w-full"
        draggable={false}
      />
    </button>
  );
}
